import React, { Suspense } from "react";
import {
  Route,
  Routes,
} from "react-router-dom";
import Layout from "../layouts";
import { ConfigProvider } from "antd";
import Loading from "../components/loading";
import { RouteProps, routes } from "./routes";

export default function CustomRoutes() {
  return (
    <ConfigProvider theme={{components: {
      Spin: { colorPrimary: "#9C0000" },
      Button: { colorPrimary: "#9C0000" },
      Menu: { colorPrimary: "#9C0000", itemColor: "#525866" },
    }}}>
      <Layout>
        <Routes>
          {routes.map(({ path, component }: RouteProps) => {
            return (
              <Route
                key={path}
                path={path}
                element={<Suspense fallback={<Loading />}>{component}</Suspense>}
              />
            );
          })}
        </Routes>
      </Layout>
    </ConfigProvider>
  );
}